<script>
  import acompanhamentoProjetoServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  import Radio from '~componentes/Radio.vue';
  import Paginacao from '~componentes/Paginacao.vue';
  import DatePicker from 'vue2-datepicker';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';

  export default {
    components: { Paginacao, Radio, DatePicker, ModalArquivosSolicitacao },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        acompanhamentos: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        acompanhamentoSelecionado: null,
        modalArquivos: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Acompanhamento Projeto - Lista';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'idProjeto', this.value);
        });
    },
    methods: {
      camposFiltros() {
        return {
          idProjeto: '0',
          mostrarAcompanhamentos: '0',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.errors.clear();

        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return acompanhamentoProjetoServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.acompanhamentos = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.acompanhamentoSelecionado = null;
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      mostrarModalArquivos(acompanhamento) {
        this.acompanhamentoSelecionado = acompanhamento;
        this.modalArquivos = true;
      },
      respondido(acompanhamento) {
        if (acompanhamento.situacao == 3)
          return true
        else 
          return false;
      },
      listaDeProjetos() {
        return projetoServico
          .listaProjetosCoordVice()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
    },
    created() {
      this.lista(this.pagina);
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>
  
<style>
  .acompanhamentook {
    font-size: 1.40em;
    color: #1d9d2d;
    margin-left: 50px;
  }

  .acompanhamentoalert {
    font-size: 1.40em;
    color: #a6a915;
    margin-left: 50px;
  }

  .acompanhamentodanger {
    font-size: 1.40em;
    color: #f11919;
    margin-left: 50px;
  }

  .acompanhamentookg {
    font-size: 1.40em;
    color: #1d9d2d;
  }

  .acompanhamentoalertg {
    font-size: 1.40em;
    color: #a6a915;
  }

  .acompanhamentodangerg {
    font-size: 1.40em;
    color: #f11919;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="acompanhamentoSelecionado ? acompanhamentoSelecionado.idAcompanhamentoProjeto : ''"
                                tipo="acompanhamento"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-3">
                <div class="form-group">
                  <label class="control-label block">Mostrar acompanhamentos</label>

                  <radio v-model="filtros.mostrarAcompanhamentos"
                         selected-value="0"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Todos
                  </radio>
                  <radio v-model="filtros.mostrarAcompanhamentos"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Pendentes
                  </radio>
                  <radio v-model="filtros.mostrarAcompanhamentos"
                         selected-value="2"
                         type="success"
                         :inline="true">
                    Respondidos
                  </radio>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">
            <div class="alert alert-warning" role="alert" v-show="true">
              <div class="table-responsive">
                
                <table class="table table-column-code table-column-action">
                  <tr>
                    <td><i class="fa fa-check-circle acompanhamentook"></i> Acompanhamento do projeto respondido</td>
                    <td><i class="fa fa-exclamation-triangle acompanhamentoalert"></i> Acompanhamento do projeto pendente de preenchimento</td>
                    <td><i class="fa fa-times-circle acompanhamentodanger"></i> Acompanhamento do projeto em atraso, projeto bloqueado para fazer solicitações</td>
                  </tr>
                </table>                            
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Situação</th>
                    <th>Nº relatório</th>
                    <th>Projeto</th>
                    <th>Início</th>
                    <th>Fim</th>
                    <th>Pessoa responsável pelas respostas</th>
                    <th>Respondido em...</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(acompanhamento, index) in acompanhamentos">
                    <td>
                      <i class="fa fa-check-circle acompanhamentookg" v-if="acompanhamento.situacao == 4"></i> 
                      <i class="fa fa-exclamation-triangle acompanhamentoalertg" v-if="acompanhamento.situacao == 2"></i>
                      <i class="fa fa-times-circle acompanhamentodangerg" v-if="acompanhamento.situacao == 1"></i>
                    </td>
                    <td>{{ acompanhamento.numeroRelatorio || '---' }}</td>
                    <td>{{ acompanhamento.nomeProjeto || '---' }}</td>
                    <td>{{ acompanhamento.periodoRelatorioInicio || '---' }}</td>
                    <td>{{ acompanhamento.periodoRelatorioFim || '---' }}</td>
                    <td>{{ acompanhamento.assinatura || '---' }}</td>
                    <td>{{ acompanhamento.dataAssinatura | formatarData }} - {{ acompanhamento.dataAssinatura | formatarHora }}</td>
                    <td>
                      <router-link tag="button"
                                   :disabled="respondido(acompanhamento)"
                                   class="btn btn-secondary btn-xs"
                                   active-class=""
                                   v-tooltip="'Responder'"
                                   :to="{ name: 'acompanhamento-projeto.editar', params: { id: acompanhamento.idAcompanhamento, idAcompanhamento: acompanhamento.idAcompanhamentoProjeto  } }">
                        <i class="fa fa-pencil"></i>
                      </router-link>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              :disabled="respondido(acompanhamento)"
                              v-tooltip="'Listar ou adicionar arquivos do acompanhamento'"
                              @click="mostrarModalArquivos(acompanhamento)"
                              v-if="configuracao.pastaBaseAcompanhamentoProjeto !==''">
                        <i class="fa fa-archive"></i>
                      </button>

                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="9">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acompanhamento-projeto/componentes/AcompanhamentoProjetoLista.vue